// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Full-screen splash ─────────────────────────────────── */
.pl-screen {
  position: fixed;
  inset: 0;
  background: #f8fafc;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}

/* ── Centred body (icon + fact) ─────────────────────────── */
.pl-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  padding: 0 24px;
  max-width: 480px;
  width: 100%;
}

/* ── Icon ────────────────────────────────────────────────── */
.pl-icon-wrap {
  animation: plPulse 2s ease-in-out infinite;
}

.pl-icon {
  width: 96px;
  height: 96px;
  object-fit: contain;
  display: block;
  border-radius: 20px;
}

@keyframes plPulse {
  0%, 100% { transform: scale(1); }
  50%       { transform: scale(1.05); }
}

/* ── Rotating fact ───────────────────────────────────────── */
.pl-fact {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: 14px;
  line-height: 1.6;
  color: #64748b;
  text-align: center;
  min-height: 3em;       /* prevents layout jump between facts */
  margin: 0;
  transition: opacity 0.28s ease, transform 0.28s ease;
}

.pl-fact--in {
  opacity: 1;
  transform: translateY(0);
}

.pl-fact--out {
  opacity: 0;
  transform: translateY(6px);
}

/* ── Progress bar ────────────────────────────────────────── */
.pl-bar-track {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: #e2e8f0;
  overflow: hidden;
}

.pl-bar-fill {
  height: 100%;
  width: 0%;
  background: #0564fe;
  border-radius: 0 2px 2px 0;
  animation: plProgress 3.8s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

@keyframes plProgress {
  0%   { width: 0%; }
  100% { width: 100%; }
}
`, "",{"version":3,"sources":["webpack://./client/src/components/PalletLoader/PalletLoader.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,+DAA+D;AAC/D;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,YAAY,sBAAsB,EAAE;AACtC;;AAEA,+DAA+D;AAC/D;EACE,sEAAsE;EACtE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe,QAAQ,uCAAuC;EAC9D,SAAS;EACT,oDAAoD;AACtD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,0BAA0B;EAC1B,gEAAgE;AAClE;;AAEA;EACE,OAAO,SAAS,EAAE;EAClB,OAAO,WAAW,EAAE;AACtB","sourcesContent":["/* ── Full-screen splash ─────────────────────────────────── */\n.pl-screen {\n  position: fixed;\n  inset: 0;\n  background: #f8fafc;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 99999;\n}\n\n/* ── Centred body (icon + fact) ─────────────────────────── */\n.pl-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 32px;\n  padding: 0 24px;\n  max-width: 480px;\n  width: 100%;\n}\n\n/* ── Icon ────────────────────────────────────────────────── */\n.pl-icon-wrap {\n  animation: plPulse 2s ease-in-out infinite;\n}\n\n.pl-icon {\n  width: 96px;\n  height: 96px;\n  object-fit: contain;\n  display: block;\n  border-radius: 20px;\n}\n\n@keyframes plPulse {\n  0%, 100% { transform: scale(1); }\n  50%       { transform: scale(1.05); }\n}\n\n/* ── Rotating fact ───────────────────────────────────────── */\n.pl-fact {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  font-size: 14px;\n  line-height: 1.6;\n  color: #64748b;\n  text-align: center;\n  min-height: 3em;       /* prevents layout jump between facts */\n  margin: 0;\n  transition: opacity 0.28s ease, transform 0.28s ease;\n}\n\n.pl-fact--in {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.pl-fact--out {\n  opacity: 0;\n  transform: translateY(6px);\n}\n\n/* ── Progress bar ────────────────────────────────────────── */\n.pl-bar-track {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: #e2e8f0;\n  overflow: hidden;\n}\n\n.pl-bar-fill {\n  height: 100%;\n  width: 0%;\n  background: #0564fe;\n  border-radius: 0 2px 2px 0;\n  animation: plProgress 3.8s cubic-bezier(0.4, 0, 0.2, 1) forwards;\n}\n\n@keyframes plProgress {\n  0%   { width: 0%; }\n  100% { width: 100%; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
